import React from 'react';

import InputGroup from 'ub/ui/inline-text/input-group';
import FontPickerFontFamily from
  'ub/ui/inline-text/style-tab-content-components/font-picker-font-family.jsx';
import FontStyleButtonGroup from 'ub/components/properties-panel/font-style-button-group';

import formStateController from './state-controller.js';
import {defaultFont} from 'ub/fonts/font-picker/form/initial-state';

class FormFontPicker extends React.Component {
  constructor() {
    super();
    this.state = defaultFont;

    this.changeHandler = this.changeHandler.bind(this);

    formStateController
      .fontActionsSubject
      .onNext({type: 'renderInitialState'});

    this.stateSubscription = formStateController
      .stateChangedSubject
      .subscribe((newState) => {
        this.setState(newState);
      });
  }

  changeHandler(eventData) {
    formStateController.fontActionsSubject.onNext(eventData);
  }

  componentWillUnmount() {
    this.stateSubscription.dispose();
  }

  render() {
    return (
      <div>
        <div className='row-input-group form-label-font-family-input'>
          <InputGroup title='Family' newTag>
            <FontPickerFontFamily
              changeHandler={this.changeHandler}
              selectedFontFamily={this.state.family}
              selectedWeight={this.state.weight}
              selectedFontStyle={this.state.style}
              wide
              openRight
            />
          </InputGroup>
        </div>

        <div className='row-input-group form-label-font-style-input'>
          <InputGroup title='Style'>
            <div className='input-items font-style-btn-group'>
              <FontStyleButtonGroup
                changeHandler={this.changeHandler}
                textStyles={this.state.textStyles}
                allowedStyles={['bold', 'italic']}
              />
            </div>
          </InputGroup>
        </div>
      </div>
    );
  }
}

export default FormFontPicker;



// WEBPACK FOOTER //
// ./src/fonts/font-picker/form/form-field-label/font-picker.jsx